import colors from './colors';
import fonts from './fonts';

const {
  black,
  regalBlue,
  doveGray,
  silver,
  mercury,
  wildSand,
  pacificBlue,
  white,
  green,
  red,
} = colors;

const theme = {
  colors: {
    normal: black,
    active: regalBlue,
    gray4: doveGray,
    gray3: silver,
    gray2: mercury,
    gray1: wildSand,
    link: pacificBlue,
    backgroundColor: white,
    backgroundColorTransparent: 'rgba(244,244,244,0)',
    success: green,
    danger: red,
    ...colors,
  },
  margin: {
    xs: '8px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px',
    huge: '64px',
  },
  fonts,
};

export default theme;

export const imageSize = {
  bookDetail: '165px',
  bookPage: '250px',
};
